import { FC } from "react";

import CTAScreen from "./components/CTAScreen";
import Fallback from "./components/Fallback";
import SafeCountdown from "./components/SafeCountdown";

import Player from './video/';
import { connect, State, actions } from "./store";
import { JarvisResponse } from "./services/jarvis-service";

declare global {
  interface Window {
    google: any;
    videoAdConfigs: any;
  }
}

export type TAppProps = { generalState: State, jarvis: JarvisResponse, loadJarvis: () => void };

export const App: FC<TAppProps> = ({ generalState }) => {
  if (generalState === State.FINISH) {
    return <></>;
  }

  return (
    <>
      { generalState === State.FALLBACK ? <Fallback /> : null }
      { generalState !== State.FALLBACK ? <CTAScreen><Player /></CTAScreen> : null }
      { generalState !== State.CTA && <SafeCountdown /> }
    </>
  );
};

export default connect(['generalState'], actions)(App);

